import { render, staticRenderFns } from "./MaintenanceCertificationsTable.vue?vue&type=template&id=15ec1430&scoped=true&"
import script from "./MaintenanceCertificationsTable.vue?vue&type=script&lang=js&"
export * from "./MaintenanceCertificationsTable.vue?vue&type=script&lang=js&"
import style0 from "./MaintenanceCertificationsTable.vue?vue&type=style&index=0&id=15ec1430&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ec1430",
  null
  
)

export default component.exports